function renderInjectedPagination(totalPages) {
  const url = new URL(window.location.href);
  const pageSearchParam = url.searchParams.get("page");
  const currentPage = Number(`${pageSearchParam || 1}`);

  const getPages = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(`<li>
        ${
          i == currentPage
            ? `<a
            role="link"
            aria-disabled="true"
            class="pagination__item pagination__item--current fp-font-weight--semibold is-disabled"
            aria-current="page"
            aria-label="Page ${i}"
          >
            ${i}
          </a>
        `
            : `
            <a
            href="${url.origin}${url.pathname}?page=${i}"
            class="pagination__item link fp-font-weight--regular"
            aria-label="Page ${i}"
          >
            ${i}
          </a>
        `
        }
      </li>`);
    }
    return pages.join("");
  };

  return `<div class="pagination-wrapper">
    <nav class="pagination" role="navigation" aria-label="Pagination">
      <ul class="pagination__list list-unstyled" role="list">
        <li>
          <a
            ${
              currentPage === 1
                ? `
              disabled="true"
              aria-disabled="true"
            `
                : `
              href="${url.origin}${url.pathname}?page=${currentPage - 1}"
            `
            }
            class="pagination__item pagination__item--next ${currentPage === 1 ? "pagination__item-arrow-disabled" : "pagination__item-arrow"} link motion-reduce"
            aria-label="Previous page"
          >
            ‹
          </a>
        </li>
        ${getPages()}
        <li>
          <a
            ${
              currentPage === totalPages
                ? `
              disabled="true"
              aria-disabled="true"
            `
                : `
              href="${url.origin}${url.pathname}?page=${currentPage + 1}"
            `
            }
            class="pagination__item pagination__item--prev ${currentPage === totalPages ? "pagination__item-arrow-disabled" : "pagination__item-arrow"} link motion-reduce"
            aria-label="Next page"
          >
            ›
          </a>
        </li>
      </ul>
    </nav>
  </div>`;
}
